import React from "react";
import MenuBar from "../MenuBar";

export default function Report() {
  return (
    <div
      className="d-flex flex-column justify-content-center w-100 align-items-center"
      style={{ height: "100vh" }}
    >
      <div className="fixed-top py-2 lh-sm bg-orange text-white text-center fs-5">
        Report
      </div>
      <div className="uil uil-traffic-barrier lh-1 fs-xxl text-grey"></div>
      <div className="text-muted fs-1">Coming soon</div>

      <div className="text-grey px-5 text-center mt-3">
        This page is under construction. Stay tuned for more updates
      </div>
      <MenuBar active="Report" />
    </div>
  );
}
